import { gql } from "@apollo/client";
import type { MockedResponse } from "@apollo/client/testing";

export const GET_FIELD_VALUES = gql`
  query (
    $filterName: String!
    $contains: String
    $limit: Int
    $with_total_count: Boolean!
    $filters_config: FiltersConfigInput
    $with_coverage: Boolean!
  ) {
    finding_filter_data(
      filter_name: $filterName
      contains: $contains
      limit: $limit
      filters_config: $filters_config
      with_coverage: $with_coverage
    ) {
      values
      field
      total_count @include(if: $with_total_count)
      values_with_coverage @include(if: $with_coverage)
    }
  }
`;

export const CREATE_FINDINGS = gql`
  mutation addManualFindings(
    $file_name: String
    $manual_findings: [ManualFindingInput]
    $bulk_id: String
  ) {
    add_manual_findings(
      manual_findings: $manual_findings
      bulk_id: $bulk_id
      file_name: $file_name
    ) {
      findings {
        id
        id_int
      }
    }
  }
`;
export const GET_MANUAL_FINDINGS_PREVIEW = gql`
  query get_manual_findings_preview($manual_findings: [ManualFindingInput]) {
    get_manual_findings_preview(manual_findings: $manual_findings) {
      existing_resources_count
      existing_findings_count
      incoming_unique_finding_ids_count
      bulk_id
    }
  }
`;

interface GenerateAddManualFindingsOptions {
  variables?: Record<string, unknown> | null;
  result?: Record<string, unknown> | null;
  error?: Error | null;
}

export const generateAddManualFindings = ({
  variables = null,
  result = null,
  error = null,
}: GenerateAddManualFindingsOptions): MockedResponse => {
  // Cast: `variables` may be null (default), but GraphQLRequest types it as
  // `Record<string, any> | undefined`. The null is preserved to keep exact
  // runtime behavior of the original JS mock factory.
  let addManualFindingsMock = {
    request: {
      query: CREATE_FINDINGS,
      variables,
    },
  } as MockedResponse;

  if (error) {
    return {
      ...addManualFindingsMock,
      error: error,
    };
  }

  if (result) {
    return {
      ...addManualFindingsMock,
      result: { data: result },
    };
  }

  return {
    ...addManualFindingsMock,
    result: {},
  };
};
